// File Imports
import React, { Component } from 'react';
import FabricCanvas from './components/FabricCanvas';
import './App.css';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
       activeProperty : null
    };
  }

  render() {
    
    return (
        <div className="container-fluid">
           <div className="canvasarea">
              <FabricCanvas 
                 activeProperty = {this.state.activeProperty}
                 />
           </div>
        </div>

    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js